<small>
  <i class="text-muted">
    <ng-content ></ng-content>
  </i>
</small>